module.exports = __webpack_public_path__ + "img/menu-off_03.69677ae0.png";